import React, { useState } from 'react';
import './packages.css';
import { GiAfrica } from 'react-icons/gi';
import { FaChevronDown, FaChevronUp, FaBus, FaBinoculars, FaHandsHelping, FaMapMarkedAlt } from 'react-icons/fa';
import Slider from 'react-slick';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import useScrollToTop from './ScrollToTop';

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

// Slider settings
const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  pauseOnHover: true,
  fade: true,
  cssEase: 'linear',
  responsive: [
    {
      breakpoint: 768,
      settings: { slidesToShow: 1, slidesToScroll: 1, fade: true }
    }
  ]
};

// Itinerary icons + images
const itineraryIcons = [
  <FaBus />, 
  <FaBinoculars />, 
  <FaBinoculars />, 
  <FaHandsHelping />, 
  <GiAfrica />, 
  <GiAfrica />
];

const itineraryImages = [
  "/images/gira.jpg",
  "/images/LNAKURU.jpg",
  "/images/rhino.jpg",
  "/images/Elephants1.jpg",
  "/images/amboselis.jpg",
  "/images/CUBROAR.jpg"
];

// Accordion component
const DayAccordion = ({ item, isOpen, onClick }) => (
  <div className={`day-accordion${isOpen ? ' open' : ''}`}>
    <div className="day-header" onClick={onClick}>
      <h3>{item.icon} {item.day}</h3>
      <span className="toggle-icon">
        {isOpen ? <FaChevronUp /> : <FaChevronDown />}
      </span>
    </div>

    {isOpen && (
      <div className="day-content-row">
        {/* LEFT CONTENT */}
        <div className="day-text-content">
          <p className="highlight">{item.highlight}</p>
          <div className="details">
            {item.details.map((d, i) => <p key={i}>{d}</p>)}
          </div>
        </div>

        {/* RIGHT IMAGE */}
        {item.image && (
          <div className="day-image-container">
            <img src={item.image} alt={item.day} className="day-image" />
          </div>
        )}
      </div>
    )}
  </div>
);

const Packagefamily = () => {
  const [openDay, setOpenDay] = useState(null);
  const [activeTab, setActiveTab] = useState("inclusions");

  const { t } = useTranslation('packagefamily');
  useScrollToTop();

  const itinerary = t("itinerarySection.days", { returnObjects: true });
  const title = t("activitiesSection.title");
  const activities = t("activitiesSection.activities", { returnObjects: true });

  return (
    <div className="package">
      
      {/* HERO */}
      <section className="package-hero">
        <img src="/images/rhinos.jpg" alt="Family Safari" className="hero-image" />
        <div className="phero-overlay" />
        <div className="phero-text">
          <h1>{t('familyPage.title')}</h1>
          <p>{t('familyPage.description')}</p>
        </div>
      </section>

      {/* INTRO */}
      <section className="package-intro">
        <div className="package-intro-content">
          <h2>{t('familyPage.intro.heading')}</h2>
          <p>{t('familyPage.intro.paragraph1')}</p>
          <p>{t('familyPage.intro.paragraph2')}</p>
          <p>{t('familyPage.intro.paragraph3')}</p>
        </div>
      </section>

      {/* CAROUSELS */}
      <section className="package-carousel-wrapper">
        {/* First Carousel */}
        <div className="carousel-container">
          <Slider {...sliderSettings}>
            <div><img src="/images/LNAKURU.jpg" alt="Mara 1" className="carousel-image" /></div>
            <div><img src="/images/girafecentre.jpeg" alt="Mara 2" className="carousel-image" /></div>
            <div><img src="/images/elephants.jpg" alt="Nakuru 1" className="carousel-image" /></div>
          </Slider>
        </div>

        {/* Second Carousel (hidden on mobile) */}
        <div className="carousel-container hide-on-mobile">
          <Slider {...sliderSettings}>
            <div><img src="/images/flamingo.jpg" alt="Nakuru 2" className="carousel-image" /></div>
            <div><img src="/images/ZEBRA ATTACK.jpg" alt="Naivasha 1" className="carousel-image" /></div>
            <div><img src="/images/kids.jpeg" alt="Naivasha 2" className="carousel-image" /></div>
          </Slider>
        </div>
      </section>

      {/* ACTIVITIES */}
      <section className="activities-section">
        <div className="activities container">
          <h2 className="activities-title">{title}</h2>
          <div className="activities-card">
            <ul className="activities-list">
              {activities.map((item, idx) => (
                <li key={idx}>
                  <strong>{item.title}</strong> — {item.description}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* ITINERARY */}
      <section className="package-itinerary">
        <div className="itinerary-content">
          <h2><FaMapMarkedAlt /> Family Safari Itinerary</h2>
          <div className="accordion-wrapper">
            {itinerary.map((item, i) => (
              <DayAccordion
                key={i}
                item={{ ...item, icon: itineraryIcons[i], image: itineraryImages[i] }}
                isOpen={openDay === i}
                onClick={() => setOpenDay(openDay === i ? null : i)}
              />
            ))}
          </div>
        </div>
      </section>

      {/* ACCOMMODATION */}
      <div className='accomodation-card'>
      {/* On Budget Card */}
      <h5>{t('accommodation.onBudgetTitle')}</h5>
      <div className='onBudget-card'>
        <div className='charge-section'>
          <table>
            <thead>
              <tr>
                <th>{t('accommodation.table.months')}</th>
                <th>{t('accommodation.table.onePerson')}</th>
                <th>{t('accommodation.table.twoToThree')}</th>
                <th>{t('accommodation.table.fourToSix')}</th>
                <th>{t('accommodation.table.sevenPlus')}</th>
                <th>{t('accommodation.table.youngAdult')}</th>
                <th>{t('accommodation.table.child')}</th>
              </tr>
            </thead>
            <tbody>
              {t('accommodation.onBudgetRows', { returnObjects: true }).map((row, index) => (
                <tr key={index}>
                  <td>{row.months}</td>
                  <td>{row.onePerson}</td>
                  <td>{row.twoToThree}</td>
                  <td>{row.fourToSix}</td>
                  <td>{row.sevenPlus}</td>
                  <td>{row.youngAdult}</td>
                  <td>{row.child}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className='accomodationImg-card'>
           <img src="/images/Accommodation-1.jpg" alt={t('accommodation.budgetAlt')} />
        </div>
      </div>

      {/* Luxury Tented Camp */}
      <h5>{t('accommodation.luxuryTitle')}</h5>
      <div className='luxury-card'>
        <div className='accomodationImg-card'>
           <img src="/images/amboseliserena-40.jpg" alt={t('accommodation.luxuryAlt')} />
        </div>
        <div className='charge-section'>
          <table>
            <thead>
              <tr>
                <th>{t('accommodation.table.months')}</th>
                <th>{t('accommodation.table.onePerson')}</th>
                <th>{t('accommodation.table.twoToThree')}</th>
                <th>{t('accommodation.table.fourToSix')}</th>
                <th>{t('accommodation.table.sevenPlus')}</th>
                <th>{t('accommodation.table.youngAdult')}</th>
                <th>{t('accommodation.table.child')}</th>
              </tr>
            </thead>
            <tbody>
              {t('accommodation.luxuryRows', { returnObjects: true }).map((row, index) => (
                <tr key={index}>
                  <td>{row.months}</td>
                  <td>{row.onePerson}</td>
                  <td>{row.twoToThree}</td>
                  <td>{row.fourToSix}</td>
                  <td>{row.sevenPlus}</td>
                  <td>{row.youngAdult}</td>
                  <td>{row.child}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <p className='volnote'>
        <b>{t('accommodation.noteLabel')}</b> {t('accommodation.noteText')}
      </p>
    </div>

      {/* INCLUSIONS / EXCLUSIONS */}
     <section className="package-details-wrapper">
  <div className="left-section">
    <div className="card-container">
      {activeTab === "inclusions" ? (
        <div className="inclusions-card">
          <div className="tab-buttons">
            <button
              className={activeTab === "inclusions" ? "active" : ""}
              onClick={() => setActiveTab("inclusions")}
            >
              {t('packageDetails.tabs.inclusions')}
            </button>
            <button
              className={activeTab === "exclusions" ? "active" : ""}
              onClick={() => setActiveTab("exclusions")}
            >
              {t('packageDetails.tabs.exclusions')}
            </button>
          </div>
          <br />
          <h3>{t('packageDetails.titles.inclusions')}</h3>
          <ul className="inclusions-list">
            {t('packageDetails.inclusions.items', { returnObjects: true }).map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        </div>
      ) : (
        <div className="exclusions-card">
          <div className="tab-buttons">
            <button
              className={activeTab === "exclusions" ? "active" : ""}
              onClick={() => setActiveTab("exclusions")}
            >
              {t('packageDetails.tabs.exclusions')}
            </button>
            <button
              className={activeTab === "inclusions" ? "active" : ""}
              onClick={() => setActiveTab("inclusions")}
            >
              {t('packageDetails.tabs.inclusions')}
            </button>
          </div>
          <br />
          <h3>{t('packageDetails.titles.exclusions')}</h3>
          <ul className="exclusions-list">
            {t('packageDetails.exclusions.items', { returnObjects: true }).map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  </div>

  <div className="planner-info">
    <img src="/images/Hazel.jpeg" alt={t('packageDetails.planner.alt')} />
    <h4>{t('packageDetails.planner.name')}</h4>
    <p>Safari Planner</p>
    <p>
      <a href="tel:+254727221650">+254 727 221 650</a>
    </p>
    <p>
      <a href="mailto:sirintai@oleninisafaris.com">sirintai@oleninisafaris.com</a>
    </p>
  </div>
</section>

      {/* CTA */}
      <section className="place-cta" aria-label={t('cta.ariaLabel')}>
        <h2>{t('cta.heading')}</h2>
        <p>{t('cta.paragraph')}</p>
        <Link to="/contact?source=packagefamily" className="book-now">
          {t('cta.buttonText')}
        </Link>
      </section>
    </div>
  );
};

export default Packagefamily;
